import { MsalGuardConfiguration, MsalInterceptorConfiguration, MsalService } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, PublicClientApplication, ServerResponseType } from '@azure/msal-browser';
import { environment } from '../../environments/environment';
import { locationUtils } from '../shared';

export function MSALInstanceFactory() {
  return new PublicClientApplication({
    auth: {
      clientId: environment.clientID,
      authority: environment.authority,
      redirectUri: `${locationUtils.getOrigin()}/login`,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: true,
    },
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return <MsalInterceptorConfiguration>{
    interactionType: InteractionType.Redirect,
  };
}

export function initializeMsalInstance(msalService: MsalService): () => Promise<void> {
  return async () => {
    await msalService.instance.initialize();
  };
}

export function setRedirectUrl() {
  const pathName = locationUtils.getPathName();
  const search = locationUtils.getSearch();
  const hash = locationUtils.getHash();
  const fullPath = pathName + search + hash;

  if (!pathName.includes('/login')) {
    const previousUrl = localStorage.getItem('previousUrl');
    if (previousUrl === pathName) {
      localStorage.setItem('redirectUrl', '/dashboard');
    } else {
      localStorage.setItem('redirectUrl', fullPath);
    }
  }
}
